import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import WizardPaso2 from '../components/WizardPaso6';
import { AppAgendaContext } from '../context/AppAgendaContext';
import { createAgendamiento, nuevoPaciente } from '../services/api/authService';
import { generarFirmaDesdeContexto } from '../utils/generarFirma';
import { FaMapMarkerAlt } from 'react-icons/fa';

const ConfirmaAgendamiento = () => {
  useEffect(() => {
    const paso = "ConfirmaAgendamiento";

    if (!validarPaso(paso)) {
      registrarEventoVisual({
        paso,
        evento: "flujo_bloqueado",
        descripcion: "Intento de acceso directo no autorizado.",
      });
      window.location.href = "/"; // redirige al inicio
      return;
    }

    setPasoActual(paso);
    agregarPasoPermitido(paso);

    logEventoBD({
      paso: 'ConfirmaAgendamiento',
      evento: 'carga_pagina',
      descripcion: 'Usuario accede al paso ConfirmaAgendamiento'
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "paso_confirma_agendamiento" });
    setUltimoEventoGTM("paso_confirma_agendamiento");
  }, []);

  const navigate = useNavigate();
  const { contextData, setPasoActual, setUltimoEventoGTM, sessionId, utmData, registrarEventoVisual, validarPaso, agregarPasoPermitido, logEventoBD } = useContext(AppAgendaContext);
  const [agendamiento, setAgendamiento] = useState(null);

  useEffect(() => {
    const agendamientoRealizado = sessionStorage.getItem('agendamientoRealizado');
    if (agendamientoRealizado === 'true') return;

    // Función para envío Seguro a Meta (CAPI) vía servidor CRM
    const enviarEventoCAPI = async (datos) => {
      try {
        await fetch('https://confirmahora.morapavic.cl/confirmar-hora/meta_capi.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-App-Service-Token': 'MPt0K3N.,MEt@eVEnTS#_4geNDa_R3G'
          },
          body: JSON.stringify({
            pixel_key: "agenda_principal",
            eventName: "Schedule",
            userData: {
              em: datos.pacCorreo || "",
              ph: datos.pacTelefono || ""
            },
            customData: {
              content_name: "Agendamiento Clínica",
              sucursal: datos.sucursalNombre || "N/A",
              fecha: datos.ageFecha || "",
              hora: datos.ageHora || ""
            }
          })
        });
        console.log("[CAPI] Evento enviado al servidor exitosamente");
      } catch (error) {
        console.error("[CAPI Error] No se pudo conectar con el proxy:", error);
      }
    };

    const enviarAgendamiento = async () => {
      const { pacienteEstado, pacRut, pacDv, pacNombre, pacCorreo, pacTelefono } = contextData;

      const nombreSeparado = pacNombre ? pacNombre.split(' ') : [];
      const pacNombrePart1 = nombreSeparado[0] || '';
      const pacApellidoPat = nombreSeparado[1] || '';
      const pacApellidoMat = nombreSeparado.slice(2).join(' ') || '';

      if (pacienteEstado === 'Web2_p') {
        if (!pacRut || !pacDv || !pacNombrePart1 || !pacApellidoPat || !pacCorreo || !pacTelefono) return;
        try {
          await nuevoPaciente({
            pacRut,
            pacDv,
            pacNombre: pacNombrePart1,
            pacApellidoPat,
            pacApellidoMat,
            pacCorreo,
            pacMovil: pacTelefono,
          });
        } catch (error) {
          return;
        }
      }

      try {
        const agendamientoData = {
          horId: contextData.horId,
          ageFecha: contextData.ageFecha,
          ageHora: contextData.ageHora,
          ageHoraFin: contextData.ageHoraFin,
          pacRut: contextData.pacRut,
          ageBloques: 2,
          tiphoId: contextData.tiphoId,
          ageNotas: '',
          sillID: contextData.sillID,
          odontRut: contextData.odontRut,
          agendaRut: '',
        };

        const response = await createAgendamiento(agendamientoData);
        sessionStorage.setItem('agendamientoRealizado', 'true');
        setAgendamiento(response.data);

        console.log("ANTES DE FBQ", typeof window.fbq);

        // META PIXEL: Ejecución híbrida (primero REACT + CAPI Servidor CRM)

        // 1. Intento por Navegador
        if (typeof window.fbq === "function") {
          window.fbq("trackSingle", "1247467163898172", "Schedule", {
            content_name: "Agendamiento Clínica",
            status: "confirmado",
            sucursal: contextData.sucursalNombre || "N/A",
            fecha: contextData.ageFecha || "",
            hora: contextData.ageHora || ""
          });
          console.log("[MetaPixel-Browser] Enviado");
        }

        // 2. Ejecución por Servidor CRM (CAPI)
        enviarEventoCAPI(contextData);

        // Registro de evento en BBDD
        await logEventoBD({
          paso: "ConfirmaAgendamiento",
          evento: "meta_conversion_hibrida_lanzada",
          descripcion: "Se intentó envío por Browser y se ejecutó llamado a CAPI CRM",
        });

        registrarEventoVisual({
          paso: 'ConfirmaAgendamiento',
          evento: 'agendamiento_exitoso',
          descripcion: `Agendamiento confirmado para ${contextData.ageFecha} ${contextData.ageHora}`
        });

        try {
          const response = await fetch('https://confirmahora.morapavic.cl/confirmar-hora/send-mail.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              token: '123abcSECRET',
              to_email: contextData.pacCorreo,
              to_name: contextData.pacNombre,
              subject: 'Confirmación de tu hora en Clínica Mora Pavic',
              fecha: contextData.ageFecha,
              hora: contextData.ageHora,
              doctor: contextData.doctorName,
              sucursal: contextData.sucursalNombre,
              direccion: contextData.sucursalDireccion,
              mapa_url: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contextData.sucursalDireccion || '')}`
            })
          });

          const result = await response.json();

          if (result.success) {
            registrarEventoVisual({
              paso: 'ConfirmaAgendamiento',
              evento: 'correo_enviado',
              descripcion: `Correo enviado a ${contextData.pacCorreo}`
            });

            await logEventoBD({
              paso: 'ConfirmaAgendamiento',
              evento: 'correo_enviado',
              descripcion: 'Se envió correctamente el correo de confirmación',
              campo: 'email',
              valor: contextData.pacCorreo
            });

            await logEventoBD({
              paso: 'ConfirmaAgendamiento',
              evento: 'flujo_finalizado',
              descripcion: 'El flujo de agendamiento fue completado correctamente, incluyendo creación y envío de confirmación'
            });

          } else {
            registrarEventoVisual({
              paso: 'ConfirmaAgendamiento',
              evento: 'correo_error',
              descripcion: 'Error al enviar el correo de confirmación'
            });

            await logEventoBD({
              paso: 'ConfirmaAgendamiento',
              evento: 'correo_error',
              descripcion: 'Fallo el envío del correo de confirmación',
              campo: 'email',
              valor: contextData.pacCorreo
            });
          }

          if (!response.ok || !result.success) {
            console.error("Error al enviar correo electrónico:", result);
          }
        } catch (error) {
          console.error("Error en fetch de envío de correo:", error);
        }

      } catch (error) {
        alert('Hubo un problema al confirmar tu agendamiento. Intenta nuevamente.');
      }
    };

    enviarAgendamiento();
  }, [contextData, navigate]);

  useEffect(() => {
    const timeout = setTimeout(async () => {
      const flujoSession = sessionStorage.getItem('flujoActivo');
      const flujoActivo = flujoSession ? JSON.parse(flujoSession) : null;

      const { urlRedireccion } = generarFirmaDesdeContexto({ flujoActivo });

      await logEventoBD({
        paso: 'ConfirmaAgendamiento',
        evento: 'redireccion_automatica',
        descripcion: 'El usuario fue redirigido automáticamente a IndexPac.js después de 10 segundos'
      });



      sessionStorage.clear();
      navigate(urlRedireccion, { replace: true });
    }, 10000);

    return () => clearTimeout(timeout);
  }, [navigate]);

  const handleNoGracias = async () => {
    const flujoSession = sessionStorage.getItem('flujoActivo');
    const flujoActivo = flujoSession ? JSON.parse(flujoSession) : null;

    const firmaGenerada = generarFirmaDesdeContexto({
      flujoActivo,
      utmData: utmData || {},            // Validamos que utmData esté disponible
      contextData: contextData || {}     // Validamos que contextData también lo esté
    });

    const { urlRedireccion } = firmaGenerada;

    await logEventoBD({
      paso: 'ConfirmaAgendamiento',
      evento: 'click_finalizar',
      descripcion: 'El usuario presionó Finalizar y fue redirigido al inicio'
    });

    sessionStorage.clear();
    navigate(urlRedireccion);
  };

  return (
    <Container>
      <WizardPaso2 />
      <Content>
        <Title>Tu hora fue <strong>AGENDADA</strong> con éxito!</Title>

        <ResumenWrapper>
          <ResumenCard>
            <CardTitle>
              <img src="/agenda/images/ico_usuario.png" alt="icono usuario" style={{ width: "30px", marginRight: "10px" }} />
              Datos del Paciente
            </CardTitle>
            <Item><strong>Nombre:</strong> {contextData.pacNombre || 'Sin nombre'}</Item>
            <Item><strong>RUT:</strong> {contextData.pacRut || '---'}</Item>
            <Item><strong>Teléfono:</strong> {contextData.pacTelefono || '---'}</Item>
            <Item><strong>Correo:</strong> {contextData.pacCorreo || '---'}</Item>
          </ResumenCard>

          <ResumenCard>
            <CardTitle>
              <img src="/agenda/images/ico_atencion.png" alt="icono atención" style={{ width: "30px", marginRight: "10px" }} />
              Información de la Atención
            </CardTitle>
            <Item><strong></strong> {contextData.doctorName || 'Sin información'}</Item>
            <Item><strong>Tipo de Atención:</strong> Evaluación Dental</Item>
            <Item><strong>Fecha:</strong> {contextData.ageFecha
              ? (() => {
                const [year, month, day] = contextData.ageFecha.split("-");
                const parsedDate = new Date(`${year}-${month}-${day}T00:00:00`);
                return parsedDate.toLocaleDateString('es-ES', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                });
              })()
              : 'Sin fecha'}
            </Item>
            <Item><strong>Hora:</strong> {contextData.ageHora || '---'}</Item>
            <Item><strong>Sucursal:</strong> {contextData.sucursalNombre || '---'}</Item>
          </ResumenCard>
        </ResumenWrapper>

        <MensajeImportante>
          <strong>Recuerde:</strong> Las radiografías tienen costo. Consulte en clínica.
        </MensajeImportante>

        {contextData.sucursalDireccion && (
          <DireccionBox>
            <strong>Dirección:</strong> {contextData.sucursalDireccion}
            <LocationContainer>
              <LocationIcon />
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contextData.sucursalDireccion)}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                (Abrir en Google Maps)
              </a>
            </LocationContainer>
          </DireccionBox>
        )}

        <ButtonGroup style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Checkmark>
            <i className="fas fa-check-circle" style={{ fontSize: '30px', color: '#00c2a8' }}></i>
          </Checkmark>
          <Button type="button" secondary onClick={handleNoGracias}>
            Finalizar
          </Button>
        </ButtonGroup>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  max-width: 900px;
  width: 100%;
  margin: 40px auto;
  padding: 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

const Content = styled.div`
  padding: 20px;
  text-align: center;
`;

const Title = styled.h3`
  color: #00608a;
  margin-bottom: 30px;
`;

const ResumenWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;

const ResumenCard = styled.div`
  flex: 1;
  min-width: 280px;
  background-color: #f0f8fa;
  border-radius: 10px;
  padding: 20px;
  text-align: left;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
`;

const CardTitle = styled.h4`
  color: #00cfd4;
  font-size: 18px;
  margin-bottom: 15px;
`;

const Item = styled.p`
  margin: 8px 0;
  font-size: 16px;
`;

const Checkmark = styled.div`
  margin: 30px 0;
  font-size: 40px;
  color: #00cfd4;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

const Button = styled.button`
  background-color: ${props => props.secondary ? '#fff' : '#00cfd4'};
  border: ${props => props.secondary ? '1px solid #6c757d' : 'none'};
  border-radius: 20px;
  color: ${props => props.secondary ? '#6c757d' : '#fff'};
  cursor: pointer;
  font-size: 16px;
  padding: 10px 20px;
  min-width: 150px;
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props => props.secondary ? '#f8f9fa' : '#00bfc4'};
  }
`;

const DireccionBox = styled.div`
  background: #d1ecf1;
  color: #0c5460;
  border: 1px solid #bee5eb;
  padding: 14px;
  margin-top: 30px;
  border-radius: 8px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;

  strong {
    color: #00547F;
  }

  a {
    color: #007bff;
    text-decoration: underline;
    margin-left: 5px;
  }
`;

const LocationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  gap: 5px;
`;

const LocationIcon = styled(FaMapMarkerAlt)`
  color: #00BEB8;
  font-size: 18px;
`;

const MensajeImportante = styled.div`
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeeba;
  border-radius: 8px;
  padding: 15px 20px;
  margin-top: 20px;
  font-size: 15px;
  font-family: 'Poppins', sans-serif;
  text-align: center;
`;

export default ConfirmaAgendamiento;
